import { __assign } from "tslib";
export { getRealMaster };
function mockParams(alignments, paddings) {
    return {
        titleParams: __assign({ title: 'dummy from info.ts', 
            // @ts-expect-error
            horizontalAlignment: alignments.Title }, paddingForInfoType('Title', paddings)),
        descriptionParams: __assign({ description: 'dummy_desc from info.ts', 
            // @ts-expect-error
            horizontalAlignment: alignments.Description }, paddingForInfoType('Description', paddings)),
        customButtonParams: __assign({ options: {
                customButtonText: 'dummy-button-text',
            }, 
            // @ts-expect-error
            horizontalAlignment: alignments.CustomButton }, paddingForInfoType('CustomButton', paddings)),
        socialParams: __assign({ viewMode: '', options: {
                galleryTextAlign: 'DUMMY',
                loveButton: true,
                allowSocial: true,
                loveCounter: false,
                allowDownload: true,
                hasThumbnails: false,
            }, 
            // @ts-expect-error
            horizontalAlignment: alignments.Social }, paddingForInfoType('Social', paddings)),
    };
}
function paddingForInfoType(iType, paddings) {
    // @ts-expect-error
    var res = paddings[iType];
    return __assign({}, res);
}
function getRealMaster(order, enabled, alignments, paddings) {
    var orderCommaSeperated = __assign({}, order);
    // @ts-expect-error
    orderCommaSeperated.top = order.top.join(',');
    // @ts-expect-error
    orderCommaSeperated.middle = order.middle.join(',');
    // @ts-expect-error
    orderCommaSeperated.bottom = order.bottom.join(',');
    return __assign(__assign({}, mockParams(alignments, paddings)), { order: orderCommaSeperated, enabled: {
            Title: enabled.Title,
            Description: enabled.Description,
            Social: enabled.Social,
            CustomButton: enabled.CustomButton,
        } });
}
//# sourceMappingURL=masterInfoPanelUtils.js.map